import { ForecastTableContentViewModel } from '../../baseTableContentViewModel';
import {
  BusinessesForSupplierForecastHeaderKey,
  ForecastForReceiptHeaderKey,
  isSupplierAnnounceKey,
} from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import { convertIDateToDateFormat, convertUnixTimeToIDate } from '../../utils/dateFormat';
import { IYearMonth } from '@/coreDomainsModule/date';
import { UserAccountService } from '@/coreDomainsModule/services/userAccountService';
import { UserAccount } from '@/coreDomainsModule/entities/users';

/**
 * 仕入先内示のテーブル表示に使うロジック
 */
export class BusinessesForSupplierForecastTableContentViewModel extends ForecastTableContentViewModel {
  /**
   * 仕入先内示の項目表示用
   * @param headerKey - ヘッダーキー
   * @param item - テーブルコンテンツアイテム
   * @param forecastStartYearMonth - 内示の開始年月
   */
  public displayForecastForReceiptItem = (
    headerKey: BusinessesForSupplierForecastHeaderKey,
    item: TableContentItem,
    forecastStartYearMonth?: IYearMonth
  ): string => {
    switch (headerKey) {
      case 'supplierForecastStaff':
        if (!item?.aggregateBusinessResponsibleUsers || item.aggregateBusinessResponsibleUsers.length === 0) return '--';
        return item.aggregateBusinessResponsibleUsers.map((user: UserAccount) => UserAccountService.getDisplayName(user)).join(', ');
      case 'supplierForecastUpdateAt': {
        if (!item.supplierForecasts || item.supplierForecasts.length === 0) return '';
        const latestUpdateAt = item.supplierForecasts.reduce((max, current) =>
          (current.supplierForecastUpdateAt ?? 0) > max.supplierForecastUpdateAt ? current : max
        ).supplierForecastUpdateAt;
        if (!latestUpdateAt) return '';
        return convertIDateToDateFormat(convertUnixTimeToIDate(latestUpdateAt));
      }
      default:
        if (isSupplierAnnounceKey(headerKey)) {
          return this._displayForecastItem(this._getForecastIndex(headerKey), item, forecastStartYearMonth);
        }
        return '';
    }
  };

  /**
   * ヘッダーのテキストを取得する
   * @param headerKey - ヘッダーキー
   * @param forecastStartYearMonth - 内示の開始年月
   */
  public getHeaderText = (headerKey: ForecastForReceiptHeaderKey, forecastStartYearMonth?: IYearMonth): string => {
    if (isSupplierAnnounceKey(headerKey)) {
      return this._forecastHeader(this._getForecastIndex(headerKey), forecastStartYearMonth);
    }
    return headerKey;
  };

  /**
   * 内示列の表示内容
   * @param index - 内示のインデックス
   * @param item - テーブルの表示内容
   * @param forecastStartYearMonth - 内示の開始年月
   */
  _displayForecastItem = (index: number, item: TableContentItem, forecastStartYearMonth?: IYearMonth): string => {
    const supplierAnnounce = item.supplierForecasts;
    if (!supplierAnnounce) return '';

    const date = this.getIYearMonth(
      forecastStartYearMonth ? new Date(forecastStartYearMonth.year, forecastStartYearMonth.month - 1) : new Date(),
      index
    );
    const yearMonthInfo = { year: date.year, month: date.month };
    const announceIndex = supplierAnnounce.findIndex(
      (item) => item.targetYear === yearMonthInfo.year && item.targetMonth === yearMonthInfo.month
    );
    if (announceIndex === -1) return '-';
    return supplierAnnounce[announceIndex].amount.addComma();
  };
}
